import { useMutation } from "@tanstack/react-query";
import { generateUploadUrl } from "src/api/pod";
const useFileUpload = ()=>{
    return useMutation({
        mutationFn: (params)=>generateUploadUrl(params)
    });
};
export default useFileUpload;
